export class SignatureDto {
  constructor(
    public readonly id: string,
    public readonly signatureData: string,
  ) {}
}
